<template>
  <!--	<transition enter-active-class="animated slideInLeft faster">-->
  <!--		-->
  <!--	</transition>-->
  <div class="sidebar" data-active-color="warning" data-color="blue">
    <!--
Tip 1: You can change the color of the sidebar using: data-color="blue | green | orange | red | yellow"
-->
    <div class="logo">
      <a v-if="sidebarMini === true" class="simple-text logo-mini" href="https://www.bigscoots.com/">
        <div class="logo-image-small">
          <img src="../../assets/img/bigscoots-logo/bigscoots-logo-mascot-white.svg">
        </div>
      </a>
      <a v-if="sidebarMini === false" class="simple-text" href="https://www.bigscoots.com/" target="_blank">
        <div class="logo-image-big">
          <img alt="BigScoots" class="center" src="../../assets/img/bigscoots-logo/logo_light.svg" width="70%">
        </div>
      </a>
    </div>
    <div class="sidebar-wrapper">
      <div class="user">
        <div class="photo">
          <img :src="`https://www.gravatar.com/avatar/${userEmailHash}?s=34`"/>
        </div>
        <div class="info">
          <a class="collapsed" data-toggle="collapse" href="#collapseExample">
							<span>
								{{ userFullName }}
								<br>
								<small>{{ emailFormatter(userEmail) }}</small>
								<b class="caret"></b>
							</span>
          </a>
          <div class="clearfix"></div>
          <div id="collapseExample" class="collapse">
            <ul class="nav">
              <router-link :to="{ name: 'editAdminProfile' }" exact-active-class="active" tag="li">
                <a>
                  <span class="sidebar-mini-icon">EP</span>
                  <span class="sidebar-normal">Edit Profile</span>
                </a>
              </router-link>
            </ul>
          </div>
        </div>
      </div>
      <ul class="nav">
        <router-link :to="{ name: 'adminDashboard' }" exact-active-class="active" tag="li">
          <a>
            <i class="fa fa-home"></i>
            <p>Dashboard</p>
          </a>
        </router-link>
        <!--              <router-link tag="li" :to="{ name: 'leaveManagement' }" exact-active-class="active">-->
        <!--                  <a>-->
        <!--                      <i class="fa fa-tag"></i>-->
        <!--                      <p>Leave Management</p>-->
        <!--                  </a>-->
        <!--              </router-link>-->
        <li :class="{'active router-link-active': statsArray.includes($route.name)}">
          <a data-toggle="collapse" href="#stats">
            <i class="fa fa-bar-chart"></i>
            <p>
              Stats
              <b class="caret"></b>
            </p>
          </a>
          <div id="stats" class="collapse">
            <ul class="nav">
              <router-link :to="{ name: 'statisticsPanel' }" exact-active-class="active" tag="li">
                <a>
                  <span class="sidebar-mini-icon">TS</span>
                  <span class="sidebar-normal"> Team Stats </span>
                </a>
              </router-link>
              <router-link :to="{ name: 'loadStats' }" exact-active-class="active" tag="li">
                <a>
                  <span class="sidebar-mini-icon">TLS</span>
                  <span class="sidebar-normal"> Ticket Load Stats </span>
                </a>
              </router-link>
            </ul>
          </div>
        </li>
        <router-link :to="{ name: 'adminLogs' }" exact-active-class="active" tag="li">
          <a>
            <i class="fa fa-list"></i>
            <p>Logs
              <!--                          <span class="badge badge-danger rounded-circle noti-icon-badge mr-3 pull-right">{{ apiErrorLogs.length }}</span>-->
            </p>
          </a>
        </router-link>
        <router-link :to="{ name: 'clientFeedback' }" exact-active-class="active" tag="li">
          <a>
            <i aria-hidden="true" class="fa fa-bullhorn"></i>
            <p>Client Feedback
              <span class="badge badge-danger rounded-circle noti-icon-badge mr-3 pull-right">{{
                  activeFeedbacks.length
                }}</span>
            </p>
          </a>
        </router-link>
        <!--                <router-link  tag="li" :to="{ name: 'outages' }" exact-active-class="active">-->
        <!--                    <a>-->
        <!--                        <i class="fa fa-exclamation-triangle"></i>-->
        <!--                        <p>Outages-->
        <!--                          <span class="badge badge-danger rounded-circle noti-icon-badge mr-3 pull-right">{{ testsOff.length }}</span>-->
        <!--                        </p>-->
        <!--                    </a>-->
        <!--                </router-link>-->
        <router-link :to="{ name: 'betteruptime' }" exact-active-class="active" tag="li">
          <a>
            <i class="fa fa-tv"></i>
            <p>Monitors
              <span class="badge badge-danger rounded-circle noti-icon-badge mr-3 pull-right">{{
                  testGroups.length
                }}</span>
            </p>
          </a>
        </router-link>
        <!--                <router-link tag="li" :to="{ name: 'createUser' }" exact-active-class="active">-->
        <!--                    <a>-->
        <!--                        <i class="fa fa-user-plus"></i>-->
        <!--                        <p>Create New User</p>-->
        <!--                    </a>-->
        <!--                </router-link>-->
        <router-link v-if="user.userType === 'admin' ||  user.userType === 'super-admin'  " :to="{ name: 'userList' }"
                     exact-active-class="active" tag="li">
          <a>
            <i class="fa fa-users"></i>
            <p>User Management</p>
          </a>
        </router-link>
        <!--                <router-link v-if="user.userType === 'admin'" tag="li" :to="{ name: 'createAdminUser' }" exact-active-class="active">-->
        <!--                    <a>-->
        <!--                        <i class="fa fa-user-secret"></i>-->
        <!--                        <p>Create Admin User</p>-->
        <!--                    </a>-->
        <!--                </router-link>-->
        <!--                <router-link v-if="user.userType === 'admin'" tag="li" :to="{ name: 'adminsList' }" exact-active-class="active">-->
        <!--                    <a>-->
        <!--                        <i class="fa fa-users"></i>-->
        <!--                        <p>Admins List</p>-->
        <!--                    </a>-->
        <!--                </router-link>-->
        <!--                <router-link tag="li" :to="{ name: 'announcements' }" exact-active-class="active">-->
        <!--                    <a>-->
        <!--                        <i class="fa fa-bullhorn"></i>-->
        <!--                        <p>Announcements</p>-->
        <!--                    </a>-->
        <!--                </router-link>-->
        <router-link :to="{ name: 'communications' }" exact-active-class="active" tag="li">
          <a>
            <i class="fa fa-bullhorn"></i>
            <p>Communications
              <span class="badge badge-danger rounded-circle noti-icon-badge mr-3 pull-right">{{
                  pendingTeamAnnouncements
                }}</span>
            </p>
          </a>
        </router-link>
        <router-link :to="{ name: 'tasks-queue' }" exact-active-class="active" tag="li">
          <a>
            <i class="fa fa-tasks"></i>
            <p>Sales <span
                class="badge badge-danger rounded-circle noti-icon-badge pull-right">{{ activeSalesTasks }}</span></p>
          </a>
        </router-link>
        <router-link :to="{ name: 'support-tasks' }" exact-active-class="active" tag="li">
          <a>
            <i class="fa fa-life-ring"></i>
            <p>
              Support
              <!--                            <span class="badge badge-default rounded-circle noti-icon-badge pull-right">{{activeSupportTasks.nonUrgent}}</span>-->
              <span
                  class="badge badge-danger rounded-circle noti-icon-badge mr-3 pull-right">{{
                  activeSupportTasks.urgent
                }}</span>
            </p>
          </a>
        </router-link>
        <router-link :to="{ name: 'migration-tasks' }" exact-active-class="active" tag="li">
          <a>
            <i class="fa fa-database"></i>
            <p>
              Migrations
              <span class="badge badge-danger rounded-circle noti-icon-badge mr-3 pull-right">{{
                  activeMigrations
                }}</span>
            </p>
          </a>
        </router-link>
        <router-link :to="{ name: 'cf-enterprise' }" exact-active-class="active" tag="li">
          <a>
            <i class="fa fa-tasks"></i>
            <p>
              PERF & Security
            </p>
          </a>
        </router-link>
        <router-link :to="{ name: 'sync-servers' }" exact-active-class="active" tag="li">
          <a>
            <i class="fa fa-tasks"></i>
            <p>
              Plans
            </p>
          </a>
        </router-link>
        <router-link :to="{ name: 'cloudflare' }" exact-active-class="active" tag="li">
          <a>
            <i class="fa fa-cloud"></i>
            <p>
              Cloudflare
              <span class="badge badge-danger rounded-circle noti-icon-badge mr-3 pull-right">{{
                  modifiedCfTasks
                }}</span>
            </p>
          </a>
        </router-link>
        <router-link :to="{ name: 'mediavine' }" exact-active-class="active" tag="li">
          <a class="d-flex ml-24 align-items-center mediavine" @click="changeColor('mediavine')">
            <svg fill="#95AAFF" height="15" viewBox="0 0 22 15" width="22" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M17.9679 6.13669L17.8085 5.82078C17.7659 5.73562 16.7785 3.74528 17.5563 2.17913C18.3341 0.612969 20.5158 0.193651 20.6087 0.177835L20.9566 0.114167L21.116 0.430075C21.1582 0.51483 22.1461 2.50558 21.3679 4.07173C20.5933 5.63505 18.4083 6.05721 18.3154 6.07302L17.9679 6.13669ZM20.4205 1.19734C19.8629 1.36442 18.8118 1.77562 18.403 2.59844C18.0182 3.37341 18.2733 4.43793 18.504 5.05109C19.0612 4.88401 20.1152 4.4724 20.5239 3.64958C20.9327 2.82676 20.6249 1.74399 20.4205 1.19734ZM4.879 4.71125C4.75978 2.18724 2.70536 0.174996 0.164719 0.111328V9.77065H0.169991C0.289622 12.2951 2.34404 14.3097 4.88184 14.3706V4.71125H4.879ZM10.4214 4.71125C10.3018 2.18724 8.24774 0.174996 5.70994 0.111328V9.77065H5.71521C5.83443 12.2951 7.88885 14.3097 10.4267 14.3706V4.71125H10.4214ZM15.9634 4.71125C15.8474 2.18724 13.793 0.174996 11.2527 0.111328V9.77065H11.258C11.3772 12.2951 13.4316 14.3097 15.9694 14.3706V4.71125H15.9634Z"/>
            </svg>
            <p class="ml-16">
              Mediavine
            </p>
          </a>
        </router-link>
        <!--              <router-link tag="li" :to="{ name: 'statisticsPanel' }" exact-active-class="active">-->
        <!--                <a>-->
        <!--                  <i class="fa fa-bar-chart"></i>-->
        <!--                  <p>-->
        <!--                    statistics-panel-->
        <!--                  </p>-->
        <!--                </a>-->
        <!--              </router-link>-->
<!--        <router-link :to="{ name: 'tools' }" exact-active-class="active" tag="li">-->
<!--          <a>-->
<!--            <i class="fa fa-wrench"></i>-->
<!--            <p>-->
<!--              Tools-->
<!--            </p>-->
<!--          </a>-->
<!--        </router-link>-->
        <li :class="{'active router-link-active': settingsArray.includes($route.name)}">
          <a data-toggle="collapse" href="#settings">
            <i class="fa fa-wrench"></i>
            <p>
              Tools
              <b class="caret"></b>
            </p>
          </a>
          <div id="settings" class="collapse">
            <ul class="nav">
              <router-link :to="{ name: 'temporaryLinks' }" exact-active-class="active" tag="li">
                <a>
                  <span class="sidebar-mini-icon">TL</span>
                  <span class="sidebar-normal"> Temporary Links </span>
                </a>
              </router-link>
              <router-link v-if="user.userType === 'admin' || user.userType === 'super-admin'" :to="{ name: 'firebaseBackups' }" exact-active-class="active" tag="li">
                <a>
                  <span class="sidebar-mini-icon">FB</span>
                  <span class="sidebar-normal"> Firebase Backups </span>
                </a>
              </router-link>
              <router-link v-if="user.userType === 'admin' || user.userType === 'super-admin'" :to="{ name: 'wpoStatus' }" exact-active-class="active" tag="li">
                <a>
                  <span class="sidebar-mini-icon">WPO</span>
                  <span class="sidebar-normal"> WPO Status </span>
                </a>
              </router-link>
              <router-link v-if="user.userType === 'admin' || user.userType === 'super-admin'" :to="{ name: 'cronLogs' }" exact-active-class="active" tag="li">
                <a>
                  <span class="sidebar-mini-icon">CL</span>
                  <span class="sidebar-normal"> Cron Logs </span>
                </a>
              </router-link>
              <router-link v-if="user.userType === 'admin' || user.userType === 'super-admin'" :to="{ name: 'massOutages' }" exact-active-class="active" tag="li">
                <a>
                  <span class="sidebar-mini-icon">MO</span>
                  <span class="sidebar-normal"> Mass Outages </span>
                </a>
              </router-link>
              <router-link :to="{ name: 'vpsBackups' }" exact-active-class="active" tag="li">
                <a>
                  <span class="sidebar-mini-icon">VPS</span>
                  <span class="sidebar-normal"> VPS Backups </span>
                </a>
              </router-link>
              <router-link :to="{ name: 'cloudflareLogs' }" exact-active-class="active" tag="li">
                <a>
                  <span class="sidebar-mini-icon">CF</span>
                  <span class="sidebar-normal"> Cloudflare Logs </span>
                </a>
              </router-link>
              <router-link :to="{ name: 'settingsBackups' }" exact-active-class="active" tag="li">
                <a>
                  <span class="sidebar-mini-icon">BU</span>
                  <span class="sidebar-normal"> Backups </span>
                </a>
              </router-link>
              <router-link :to="{ name: 'hostnameDnsAudit' }" exact-active-class="active" tag="li">
                <a>
                  <span class="sidebar-mini-icon">HD</span>
                  <span class="sidebar-normal"> Hostname DNS Audit </span>
                </a>
              </router-link>
              <router-link :to="{ name: 'nonWpoZabbixMonitors' }" exact-active-class="active" tag="li">
                <a>
                  <span class="sidebar-mini-icon">NZ</span>
                  <span class="sidebar-normal"> Non-WPO Zabbix Monitors </span>
                </a>
              </router-link>
<!--              <router-link :to="{ name: 'backupManagement' }" exact-active-class="active" tag="li">-->
<!--                <a>-->
<!--                  <span class="sidebar-mini-icon">BM</span>-->
<!--                  <span class="sidebar-normal"> Backup Management </span>-->
<!--                </a>-->
<!--              </router-link>-->
              <router-link :to="{ name: 'monitorManagement' }" exact-active-class="active" tag="li">
                <a>
                  <span class="sidebar-mini-icon">MM</span>
                  <span class="sidebar-normal"> Monitor Management </span>
                </a>
              </router-link>
              <router-link :to="{ name: 'terminatedAccountsBackups' }" exact-active-class="active" tag="li">
                <a>
                  <span class="sidebar-mini-icon">TAB</span>
                  <span class="sidebar-normal"> Terminated Backups </span>
                </a>
              </router-link>
            </ul>
          </div>
        </li>
        <router-link :to="{ name: 'vz-to-lxd' }" exact-active-class="active" tag="li">
          <a>
            <i class="fa fa-exchange"></i>
            <p>
              VZ -> LXD
            </p>
          </a>
        </router-link>
        <li :class="{'active router-link-active': lxdArray.includes($route.name)}">
          <a data-toggle="collapse" href="#lxd">
            <i class="fa fa-server"></i>
            <p>
              LXD
              <b class="caret"></b>
            </p>
          </a>
          <div id="lxd" class="collapse">
            <ul class="nav">
              <router-link :class="{active: $route.path.includes('/admin/lxd') && $route.params.id}"
                           :to="{ name: 'lxd' }"
                           exact-active-class="active" tag="li">
                <a>
                  <span class="sidebar-mini-icon">LI</span>
                  <span class="sidebar-normal"> List Instances</span>
                </a>
              </router-link>
              <router-link :to="{ name: 'create-lxd' }" exact-active-class="active" tag="li">
                <a>
                  <span class="sidebar-mini-icon">CI</span>
                  <span class="sidebar-normal"> Create Instance </span>
                </a>
              </router-link>
            </ul>
          </div>
        </li>
        <li :class="{'active router-link-active': myLeavesArray.includes($route.name)}">
          <!--                <a href="" class="line mt-0 pb-0"></a>-->
          <a data-toggle="collapse" href="#account">
            <i class="fa fa-user"></i>
            <p>
              My Account
              <b class="caret"></b>
            </p>
          </a>
          <div id="account" class="collapse">
            <ul class="nav">
              <router-link :to="{ name: 'myLeaves' }" exact-active-class="active" tag="li">
                <a>
                  <span class="sidebar-mini-icon">ML</span>
                  <span class="sidebar-normal"> My Leaves </span>
                </a>
              </router-link>
            </ul>
          </div>
        </li>
        <li v-if="isHR" :class="{'active router-link-active': hrArray.includes($route.name)}">
          <a data-toggle="collapse" href="#leaves">
            <i class="fa fa-users "></i>
            <p>
              HR
              <b class="caret"></b>
            </p>
          </a>
          <div id="leaves" class="collapse">
            <ul class="nav">
              <router-link :to="{ name: 'leaveRequests' }" exact-active-class="active" tag="li">
                <a>
                  <span class="sidebar-mini-icon">LR</span>
                  <span class="sidebar-normal"> Leave Requests </span>
                </a>
              </router-link>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import $ from "jquery/dist/jquery.slim.min";
import PerfectScrollbar from "perfect-scrollbar";
import {db} from "@/firebase/init";
import moment from "moment";

let sidebar = null;

export default {
  name: "AdminSideMenu",
  data() {
    return {
      myLeavesArray: ['myLeaves'],
      lxdArray: ['list', 'create'],
      hrArray: ['leaveRequests'],
      statsArray: ['statisticsPanel', 'loadStats'],
      settingsArray: ['temporaryLinks', 'firebaseBackups', 'wpoStatus', 'cronLogs', 'massOutages', 'vpsBackups', 'cloudflareLogs', 'settingsBackups', 'hostnameDnsAudit', 'nonWpoZabbixMonitors', 'backupManagement', 'monitorManagement', 'terminatedAccountsBackups'],
      isHR: false,
      testsOff: [],
      betteruptimeTests: [],
      apiErrorLogs: [],
      testGroups: [],
      activeFeedbacks: [],
      activeCfTasks: [],
      activeCfListener: null,
      clientFeedbackListener: null,
      pendingTeamAnnouncements: 0,
      annListener: null,
      currentToast: null,
      announcementElement: null,
      color: '#95AAFF'
    }
  },
  computed: {
    modifiedCfTasks() {
      return this.activeCfTasks.length > 0 ?  this.activeCfTasks.filter(cf => cf.cfEnterprise.status === 'pending' && !cf.cfEnterprise.checkinBy).length : 0
    },
    outages() {
      let outages = this.$store.getters['notification/getAllOutages'];
      const testIps = ['69.162.173.212', '23.29.145.209']
      outages = outages
          .filter(test => {
            return (!testIps.includes(test.serverIP) && !test.hbSuspended) && test.status === 'down'
          })
      if (this.user.email !== 'khan@bigscoots.com') {
        outages = outages.filter(el => el.serverIP !== '74.121.207.61')
      }
      return outages.filter(el => !el.type || el.type !== 'diskAlert');
    },
    sidebarMini() {
      return this.$store.getters["sidebarMini/type"]
    },
    userFullName() {
      return this.$store.getters.userFullName;
    },
    userEmail() {
      return this.$store.getters.userEmail;
    },
    userEmailHash() {
      return this.$store.getters.emailHashGravatar;
    },
    user() {
      return this.$store.getters.user;
    },
    getNotificationStatus() {
      return this.user.getNotificationStatus
    },
    activeSalesTasks() {
      return this.$store.getters['tasks/getActiveSalesTasksCount'];
    },
    activeSupportTasks() {
      return this.$store.getters['tasks/getActiveSupportTasksCount'];
    },
    activeMigrations() {
      return this.$store.getters['tasks/getActiveMigrationsCount'];
    },
  },
  watch: {
    async pendingTeamAnnouncements(val) {
      console.log('pending', val, this.currentToast)
      if (this.currentToast) {
        this.$toast.clear()
        this.currentToast = null;
      }
      if (val > 0 && this.getNotificationStatus) {
        await this.modelUp(val)
        console.log(this.currentToast)
      }
    },
    outages() {
      this.startGrouping()
    }
  },
  mounted() {

    const isWindows = navigator.platform.indexOf("Win") > -1 ? true : false;

    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      sidebar = new PerfectScrollbar(".sidebar .sidebar-wrapper");
      sidebar.update();
      //$('.sidebar .sidebar-wrapper, .main-panel').perfectScrollbar();

      $("html").addClass("perfect-scrollbar-on");
    } else {
      $("html").addClass("perfect-scrollbar-off");
    }
    // this.getTotalDownOutages()
    this.getTotalDownBetterUptimeOutages()
    this.getPendingAnnouncements()
    this.getActiveFeedbacks()
    this.getActiveCFTasks()
    this.getHrRole()

    // this.getApiErrorLogs()
  },
  methods: {
    async getHrRole() {
      const ref = await db.collection('users').doc(this.user.uid).get();
      if (ref.exists) {
        const {isHR} = ref.data()
        this.isHR = isHR;
      }
      this.loading = false;
    },
    changeColor() {
      console.log('colorr')
      if (this.color === '#95AAFF') {
        this.color = '#EAAD13'
      } else {
        this.color = '#95AAFF'
      }
    },
    emailFormatter(email) {
      if (email.length > 25) {
        return `${email.slice(0, 25)}...`
      }
      return email
    },
    getTotalDownOutages() {
      console.log('calling');

      this.testsOff = [];
      let downQuery = db.collection('status_cake_tests')
          .where('status', 'in', ['Down'])
          .limit(500);

      this.downListener = downQuery.onSnapshot(querySnapshot => {
        querySnapshot.docChanges().forEach(change => {
          switch (change.type) {
            case 'added':
              this.testsOff.unshift(change.doc.data());
              break;
            case "removed": {
              const removedData = change.doc.data();
              this.testsOff = this.testsOff.filter(test => test.testId !== removedData.testId);
            }
              break;
          }
        });
      })
    },
    getActiveFeedbacks() {
      console.log('actiive feedback')
      this.activeFeedbacks = [];
      let query = db.collection('clientFeedbacks')
          .where('status', '==', 'pending')
          .limit(500);

      this.clientFeedbackListener = query.onSnapshot(querySnapshot => {
        querySnapshot.docChanges().forEach(change => {
          const data = change.doc.data();
          console.log(change.type)
          switch (change.type) {
            case 'added':
              if (data.status === 'pending') {
                this.activeFeedbacks.push({id: change.doc.id, ...change.doc.data()});
              }
              break;
            case 'removed':
              this.activeFeedbacks = this.activeFeedbacks.filter(el => el.id !== change.doc.id);
              break;
          }
        });
      })
    },
    getActiveCFTasks() {
      console.log('actiive feedback')
      this.activeCfTasks = [];
      let query = db.collection('domains').where('cfEnterprise.status', '==', 'pending')
          .limit(500);

      this.activeCfListener = query.onSnapshot(querySnapshot => {
        querySnapshot.docChanges().forEach(change => {
          const data = change.doc.data();
          console.log(change.type)
          switch (change.type) {
            case 'added':
              this.activeCfTasks.push({id: change.doc.id, ...change.doc.data()});

              break;
            case 'removed':
              this.activeCfTasks = this.activeCfTasks.filter(el => el.id !== change.doc.id);
              break;
          }
        });
      })
    },
    startGrouping() {
      this.testGroups = []
      const testIps = ['69.162.173.212', '23.29.145.209']
      const outages = this.betteruptimeTests.filter(test => {
        return !testIps.includes(test.serverIP)
      })
      console.log('better uptime ts', outages)
      outages.map(test => {
        const planName = test.hbSuspended ? 'Suspended' : ((test.plan) ? test.plan : '(N/A)');
        let group = this.testGroups.find(g => g.planName === planName);
        if (!group) {
          group = {
            planName: planName,
            serverIP: (planName === '(N/A)') ? '' : test.serverIP,
            tests: [test],
          };
          console.log('pushing')
          this.testGroups.push(group);
        } else if (group) {
          const testExist = group.tests.find(t => (t.id === test.id));
          if (!testExist) {
            group.tests.push(test);
          }
        }
      });
    },
    async modelUp(counter) {
      console.log('counter', counter);
      const message = `You haved <strong>${counter}</strong> unacknowledged team announcement${counter === 1 ? '' : 's'}.`
      const messageTemplate = `<div class="d-flex align-items-center" id="announcementId">
          <div class="mr-5"> <i class="fa fa-info-circle fa-2x" aria-hidden="true"></i></div>
          <div class="ml-5">
          <div>
          <span>${message}</span>
          </div> </div> </div>`
      this.currentToast = await this.showToast({
        message: messageTemplate,
        pauseOnHover: true,
        duration: 0,
        dismissible: false,
        queue: true,
      }, true, 'success', true)

      setTimeout(() => {
        this.onClickHandlerForAnnouncementModal()
      }, 2000);

    },
    onClickHandlerForAnnouncementModal() {
      const id = `#announcementId`
      console.log('this id', id)
      this.announcementElement = $(id);
      if (this.announcementElement.length) {
        this.announcementElement.on('click', () => {
          if (this.pendingTeamAnnouncements === 1) {
            this.$store.commit('mutateSingleAnnouncement', true);
          }
          this.$router.push({name: 'communications'});
        });
      } else {
        console.log('Does not exist');
      }
    },
    getTotalDownBetterUptimeOutages() {
      console.log('calling');

      this.betteruptimeTests = [];
      let downQuery = db.collection('zabbixMonitors')
          .where('status', '==', 'down')
      // .limit(500);

      this.downListener = downQuery.onSnapshot(querySnapshot => {
        querySnapshot.docChanges().forEach(change => {
          switch (change.type) {
            case 'added': {
              if (!change.doc.data().hbSuspended) {
                this.betteruptimeTests.unshift(change.doc.data());
                this.startGrouping()
              }
              break;
            }
            case "removed": {
              const removedData = change.doc.data();
              this.betteruptimeTests = this.betteruptimeTests.filter(test => test.id !== removedData.id);
              this.startGrouping()
            }
              break;
          }
        });
      })
    },
    getPendingAnnouncements() {
      console.log('calling');

      this.pendingTeamAnnouncements = 0;
      let query = db.collection('team-announcements').doc('counter')
      // .limit(500);

      this.annListener = query.onSnapshot({
        // Listen for document metadata changes
        includeMetadataChanges: true
      }, (doc) => {
        // ...
        const {staffMembers} = doc.data();
        let obj = null;
        if (staffMembers.length) {
          obj = staffMembers.find(el => el.uid === this.user.uid);
          console.log('obj fooumd', obj)
          if (obj) {
            this.pendingTeamAnnouncements = obj.counter

          }
        }
        console.log('snapshot', doc.data())

      });
    },
    getApiErrorLogs() {
      this.apiErrorLogs = [];
      let query = db.collection('apiErrorLogs')
          .where('createdAt', '>=', moment(new Date()).subtract(1, 'days').toISOString())

      this.downListener = query.onSnapshot(querySnapshot => {
        querySnapshot.docChanges().forEach(change => {
          this.apiErrorLogs.unshift(change.doc.data());

        });
      })
    }
  },
  beforeDestroy() {
    if (this.annListener) {
      this.annListener()
    }
    if (this.activeCfListener) {
      this.activeCfListener()
    }
    if (sidebar) {
      sidebar.destroy();
    }
    sidebar = null;

    let $announcementElement = $('#announcementId');
    if ($announcementElement.length && this.onClickHandlerForAnnouncementModal) {
      $announcementElement.off('click', this.onClickHandlerForAnnouncementModal);
    }
  }
};
</script>

<style lang="scss">
.logo {
  min-height: 68px;
}

.sidebar .sidebar-wrapper, .off-canvas-sidebar .sidebar-wrapper {
  height: calc(100vh - 6px) !important;
}

.sidebar[data-active-color="warning"] .nav li.active > a {
  .mediavine {
    svg {
      fill: #EAAD13 !important;
    }
  }
}

.line:before {
  content: '';
  position: absolute;
  bottom: 0;
  right: 15px;
  height: 1px;
  width: calc(100% - 30px);
  background-color: rgba(255, 255, 255, 0.3);
}
</style>
